var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-form-text",on:{"click":function($event){return _vm.__eventHandler('click', _vm.formModel)}}},[(!_vm.value && _vm.formModel.rules.placeholder)?_c('span',{staticClass:"placeholder"},[_vm._v(" "+_vm._s(_vm.formModel.rules.placeholder)+" ")]):[_vm._v(_vm._s(_vm.value))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }